
(function HotelEngineRoomConfig($, Adzuki)
{
    'use strict';

    const component = {
        emits       : ['component-event', 'close-modal'],
        inheritAttrs: false,
        props       : {
            rooms: {
                type    : Array,
                required: true,
            },
            fromModal: {
                type   : Boolean,
                default: false,
            }
        },
        data() {
            return {
                baseUri          : Adzuki.base_uri,
                roomOptions      : [1, 2, 3, 4],
                adultOptions     : [1, 2, 3, 4],
                childCountOptions: [0, 1, 2, 3, 4],
                childAgeOptions  : Array.from({length: 18}, (_, i) => ({
                    value: i,
                    label: i === 0 ? '<1' : i
                })),
                formData: {
                    numRooms: 1,
                    rooms   : []
                }
            };
        },
        template: `
          <div class="form-group row">
            <slot name="num-room-container">
                <div class="col-sm-12">
                  <label class="control-label" for="num-rooms">
                    <span class="required"></span> Number of Rooms:
                  </label>
                  <select
                      id="num-rooms"
                      class="form-control"
                      :value="formData.numRooms"
                      @change="handleNumRoomsChange"
                  >
                    <option
                        v-for="n in roomOptions"
                        :key="'rooms-' + n"
                        :value="n"
                    >{{ n }}</option>
                  </select>
                </div>
            </slot>
          </div>
          <div
              v-for="room in formData.rooms"
              :key="'room-' + room.roomNumber"
              :id="'room-' + room.roomNumber"
              class="room"
          >
            <div class="row">
              <hgroup class="col-sm-12 box-content-title pad10-vert-bottom">
                <h4>Room {{ room.roomNumber }}</h4>
              </hgroup>
            </div>

            <!-- Number of Adults -->
            <div class="form-group row">
              <slot name="num-adults-container">
                  <label class="col-sm-4 control-label text-right" for="numAdults"><span
                      class="required"></span> Number of Adults:</label>
                  <div class="col-sm-8">
                    <select
                        id="numAdults"
                        class="form-control"
                        :value="room.numAdults"
                        @change="updateRoom(room.roomNumber, 'numAdults', $event.target.value)"
                    >
                      <option
                          v-for="n in adultOptions"
                          :key="'adults-' + room.roomNumber + '-' + n"
                          :value="n"
                      >{{ n }}</option>
                    </select>
                  </div>
              </slot>
            </div>
            <div class="form-group row">
              <slot name="num-children-container">
                  <label class="col-sm-4 control-label text-right" for="numChildren"><span class="required"></span> Number of Children:</label>
                  <div class="col-sm-8">
                    <select
                        id="numChildren"
                        class="form-control"
                        :value="room.numChildren"
                        @change="updateRoom(room.roomNumber, 'numChildren', $event.target.value)"
                    >
                      <option
                          v-for="n in childCountOptions"
                          :key="'children-' + room.roomNumber + '-' + n"
                          :value="n"
                      >{{ n }}</option>
                    </select>
                  </div>
              </slot>
            </div>
            <div
                v-if="room.childrenAges && room.childrenAges.length > 0"
                v-for="(age, index) in room.childrenAges"
                :key="'child-' + room.roomNumber + '-' + index"
                :class="{ 'form-group row': true, ['child-' + room.roomNumber + '-' + index]: true }"
            >
              <slot name="child-age-container">
                  <label class="col-sm-4 control-label text-right" for="childAge">
                    <span class="required"></span> Child Age ({{ index + 1 }}):
                  </label>
                  <div class="col-sm-8">
                    <select
                        id="childAge"
                        class="form-control"
                        :value="room.childrenAges[index]"
                        @change="updateChildAge(room.roomNumber, index, $event.target.value)"
                    >
                      <option
                          v-for="n in childAgeOptions"
                          :key="'age-' + room.roomNumber + '-' + index + '-' + n.value"
                          :value="n.value"
                      >{{ n.label }}</option>
                    </select>
                  </div>
              </slot>
            </div>
          </div>
          <slot name="room-config-button">
              <div class="form-group row">
                <div class="col-sm-12 text-right">
                  <button type="button" @click="updateRoomConfig" class="btn btn-primary">Confirm Rooms</button>
                </div>
              </div>
          </slot>
        `,
        methods: {
            updateRoomConfig() {
                this.$emit('component-event', this.formData);
            },
            updateRoom(roomNumber, field, value) {
                const room = this.formData.rooms.find(r => r.roomNumber === roomNumber);

                if (room) {
                    if (field === 'numChildren') {
                        const childCount = parseInt(value, 10);
                        room.numChildren = childCount;

                        if (childCount > 0) {
                            const newChildrenAges = [];
                            for (let i = 0; i < childCount; i++) {
                                const existing = room.childrenAges?.[i];
                                newChildrenAges[i] = existing === '' || existing === undefined
                                    ? 0
                                    : parseInt(existing, 10);
                            }
                            room.childrenAges = newChildrenAges;
                        } else {
                            room.childrenAges = [];
                        }
                    } else if (field === 'numAdults') {
                        room.numAdults = parseInt(value, 10);
                    }
                }
            },
            updateChildAge(roomNumber, index, value) {
                const room = this.formData.rooms.find(r => r.roomNumber === roomNumber);

                if (room && room.childrenAges) {
                    room.childrenAges[index] = parseInt(value, 10);
                }
            },
            handleNumRoomsChange(event) {
                const value = parseInt(event.target.value, 10);

                this.formData.numRooms = value;

                const currentCount = this.formData.rooms.length;
                if (value > currentCount) {
                    for (let i = currentCount; i < value; i++) {
                        this.formData.rooms.push({
                            roomNumber  : i + 1,
                            numAdults   : 2,
                            numChildren : 0,
                            childrenAges: []
                        });
                    }
                } else if (value < currentCount) {
                    this.formData.rooms = this.formData.rooms.slice(0, value);
                }

                if (!this.fromModal) {
                    this.$emit('component-event', this.formData);
                }
            }
        },
        watch: {
            rooms: {
                deep: true,
                handler(newRooms) {
                    if (Array.isArray(newRooms) && newRooms.length > 0) {
                        this.formData.numRooms = newRooms.length;
                        this.formData.rooms = JSON.parse(JSON.stringify(newRooms));
                    }
                }
            },
        },
        mounted() {
            if (this.rooms && this.rooms.length > 0) {
                this.formData.numRooms = this.rooms.length;
                this.formData.rooms    = JSON.parse(JSON.stringify(this.rooms));
            }
        }
    };

    Adzuki.VueComponents.HotelEngineRoomConfig = component;
}(jQuery, window.Adzuki || {}));
